import BugsDevDashboard from "./BugsDevDashboard";
import { useSelector } from "react-redux";
import type { RootState } from "../../store/Index";
import { type User } from "../../store/slice/AuthSlice";

import BugsAdminDashboard from "./BugsAdminDashboard";

const BugsDashboard = () => {
  const user = useSelector(
    (state: RootState) => state.auth.user,
  ) as User | null;

  const users = useSelector((state: RootState) => state.users.users);

  const userDetails = users.find((u) => u.id === user?.id);
  const role = user?.role ?? userDetails?.role;

  if (role?.toLowerCase() === "admin") {
    return <BugsAdminDashboard />;
  }

  return <BugsDevDashboard />;
};

export default BugsDashboard;
